/**
 * Ticket ME1: Serverfunktionen der öffentlichen Mentoring-Seiten.
 *
 * Bewusst ohne Anmeldezwang (Besucher sind nicht angemeldet), ausschließlich
 * lesend, mit fester Feldauswahl im Server-Teil. Die Sichtbarkeit entscheidet
 * die Leseschicht: Funktionsschalter, Status, und für interne Rollen der Blick
 * auf den noch verborgenen Bereich.
 */

import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import { mentoringSlugSchema } from "@/lib/mentorings";

export const listPublicMentorings = createServerFn({ method: "GET" }).handler(async () => {
  const { listPublicMentoringsOnServer } = await import("@/lib/mentorings.server");
  return listPublicMentoringsOnServer();
});

export const getPublicMentoring = createServerFn({ method: "GET" })
  .inputValidator((data: { slug: string }) =>
    z.object({ slug: mentoringSlugSchema }).parse(data),
  )
  .handler(async ({ data }) => {
    const { getPublicMentoringOnServer } = await import("@/lib/mentorings.server");
    return getPublicMentoringOnServer(data.slug);
  });

